import { companyManagedList } from '@/api/employee'

// 将接口返回的字段统一为选择器通用字段
function normalize(item) {
    return {
        ...item,
        id: item.userId,
        name: item.userName,
    }
}

export default {

    namespaced: true,

    state() {
        return {
            loading: false,
            list: [], // 公司管理人员列表
            recentSelectedList: [], // 最近选中
        }
    },


    mutations: {
        setLoading(state, payload) {
            state.loading = payload
        },
        setList(state, payload) {
            state.list = payload
        },
        setRecentSelectedList(state, payload) {
            window.localStorage.setItem('company-managed-recent-selected-list', JSON.stringify(payload)) // 将最近选中的数据存储在 localStorage 中
            state.recentSelectedList = payload;
        },
    },

    actions: {
        getList({ commit }, params = {}) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                companyManagedList(params).then(res => {
                    if (Array.isArray(res)) {
                        const list = res.map(normalize)
                        commit('setList', Object.freeze(list))
                        resolve(list);
                    } else {
                        resolve([]);
                    }
                }).catch(() => {
                    resolve([]);
                }).finally(() => {
                    commit('setLoading', false)
                })
            })


        }
    }

}
